import { useState } from 'react';

export interface PasswordForm {
  oldPassword: string;
  newPassword: string;
  newPasswordRepeated: string;
}

export enum PasswordErrors {
  OLD_INVALID = 'old-invalid',
  NEW_TOO_SHORT = 'new-too-short',
  NEW_TOO_LONG = 'new-too-long',
  REPEATED_NO_MATCH = 'repeated-no-match',
}

const defaultForm: PasswordForm = {
  oldPassword: '',
  newPassword: '',
  newPasswordRepeated: '',
};

const usePasswordForm = () => {
  const [password, setPassword] = useState(defaultForm);

  const onPasswordChange = (field: keyof PasswordForm) => {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
      const updatePassword = { ...password };
      updatePassword[field] = event.target.value;
      setPassword(updatePassword);
    };
  };

  const resetPasswordForm = () => {
    setPassword(defaultForm);
  };

  return {
    oldPassword: password.oldPassword,
    newPassword: password.newPassword,
    newPasswordRepeated: password.newPasswordRepeated,
    onPasswordChange,
    resetPasswordForm,
  };
};

export default usePasswordForm;
